"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StyledFile;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.reflect.get");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.string.starts-with");

var _File = _interopRequireDefault(require("./File"));

var _jsFileDownload = _interopRequireDefault(require("js-file-download"));

var _fetchPonyfill2 = _interopRequireDefault(require("fetch-ponyfill"));

var _WithLogic2 = _interopRequireDefault(require("../../utils/WithLogic"));

var _WithFileUtils = require("../../utils/WithFileUtils");

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var _fetchPonyfill = (0, _fetchPonyfill2.default)(),
    fetch = _fetchPonyfill.fetch;

function StyledFile(setting) {
  var baseUrl = setting.baseUrl;
  return (
    /*#__PURE__*/
    function (_WithLogic) {
      _inherits(_class, _WithLogic);

      function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
      }

      _createClass(_class, [{
        key: "build",
        value: function build() {
          // Restore the value.
          //Изменение порядка вывода элементов
          this.restoreValue();
          var labelAtTheBottom = this.component.labelPosition === 'bottom';
          this.createElement();

          if (!labelAtTheBottom) {
            this.createLabel(this.element);
          }

          this.inputsContainer = this.ce('div');
          this.errorContainer = this.inputsContainer;
          this.createErrorElement();
          this.listContainer = this.buildList();
          this.uploadContainer = this.buildUpload();
          this.hiddenFileInputElement = this.buildHiddenFileInput();
          this.hook('input', this.hiddenFileInputElement, this.inputsContainer);
          this.inputsContainer.appendChild(this.hiddenFileInputElement);
          this.inputsContainer.appendChild(this.uploadContainer);
          this.inputsContainer.appendChild(this.listContainer);
          this.addWarnings(this.inputsContainer);
          this.buildUploadStatusList(this.inputsContainer);
          this.setInputStyles(this.inputsContainer);
          this.element.appendChild(this.inputsContainer);

          if (labelAtTheBottom) {
            this.createLabel(this.element);
          }

          this.createDescription(this.element);
          this.autofocus(); // Disable if needed.

          if (this.shouldDisable) {
            this.disabled = true;
          }

          this.attachLogic();
        }
      }, {
        key: "buildHiddenFileInput",
        value: function buildHiddenFileInput() {
          //Добавление событий Drag&Drop к HiddenFileInput
          var _this4 = this; // Drop event must change this pointer so need a reference to parent this.


          var element = this; // Declare Camera Instace
          // Input needs to be in DOM and "visible" (opacity 0 is fine) for IE to display file dialog.

          return this.ce('input', {
            type: 'file',
            style: 'opacity: 0; position: absolute;',
            tabindex: -1,
            // prevent focus
            onChange: function onChange() {
              _this4.upload(_this4.hiddenFileInputElement.files);

              _this4.hiddenFileInputElement.value = '';
            },
            onDragover: function onDragover(event) {
              var fileSelectorContainer = _this4.uploadContainer.firstChild;
              fileSelectorContainer.className = 'fileSelector fileDragOver';
              event.preventDefault();
            },
            onDragleave: function onDragleave(event) {
              var fileSelectorContainer = _this4.uploadContainer.firstChild;
              fileSelectorContainer.className = 'fileSelector';
              event.preventDefault();
            },
            onDrop: function onDrop(event) {
              var fileSelectorContainer = _this4.uploadContainer.firstChild;
              fileSelectorContainer.className = 'fileSelector';
              event.preventDefault();
              element.upload(event.dataTransfer.files);
              return false;
            }
          });
        }
      }, {
        key: "loadImage",
        value: function loadImage(fileInfo) {
          return this.fileService.downloadFile(fileInfo).then(function (result) {
            var path = result.url,
                pathPrefix = path.startsWith('/') ? '' : '/',
                url = path.startsWith('http') ? path : "".concat(baseUrl).concat(pathPrefix).concat(path);
            return url;
          });
        }
      }, {
        key: "createUploadStatus",
        value: function createUploadStatus(fileUpload) {
          var _this13 = this;

          var container;
          return container = this.ce('div', {
            class: 'file'.concat(fileUpload.status === 'error' ? ' has-error' : '')
          }, [this.ce('div', {
            class: 'list-item'
          }, [this.ce('div', {
            class: 'file-list__file-name'
          }, this.fileNameWithoutExt(fileUpload)), this.ce('div', {
            class: 'file-list__file-ext'
          }, this.fileExt(fileUpload)), this.ce('div', {
            class: 'file-list__file-size'
          }, this.fileSize(fileUpload.size)), this.ce('div', {
            class: 'file-list__file-remove'
          }, this.ce('i', {
            class: 'theme-icon-trash',
            onClick: function onClick() {
              return _this13.removeChildFrom(container, _this13.uploadStatusList);
            }
          }))]), this.ce('div', {
            class: 'progress-block'
          }, [fileUpload.status === 'progress' ? this.ce('div', {
            class: 'progress'
          }, this.ce('div', {
            class: 'progress-bar',
            role: 'progressbar',
            'aria-valuenow': fileUpload.progress,
            'aria-valuemin': 0,
            'aria-valuemax': 100,
            style: 'width:'.concat(fileUpload.progress, '%')
          }, [this.ce('span', {
            class: 'sr-only'
          }, ''.concat(fileUpload.progress, '% Complete')), this.ce('div', {
            class: 'lines'
          })])) : this.ce('div', {
            class: 'bg-'.concat(fileUpload.status)
          }, fileUpload.message)])]);
        } // Добавлен triggerChange при успешном удалении

      }, {
        key: "removeChildFrom",
        value: function removeChildFrom(element, container) {
          if (container && container.contains(element)) {
            try {
              container.removeChild(element);
            } catch (err) {
              console.warn(err);
            }
          }

          return this;
        } //Изменения: не резолвился промис dataReady для image файлов, если не было ни одного файла

      }, {
        key: "setValue",
        value: function setValue(value) {
          var _this2 = this;

          this.setVisibility(value);
          var newValue = value || [];
          this.dataValue = newValue;

          if (this.component.image) {
            this.loadingImages = [];
            var images = Array.isArray(newValue) ? newValue : [newValue];
            images.map(function (fileInfo) {
              if (fileInfo && Object.keys(fileInfo).length) {
                _this2.loadingImages.push(_this2.loadImage(fileInfo));
              }
            });

            if (this.loadingImages.length) {
              Promise.all(this.loadingImages).then(function () {
                _this2.refreshDOM();

                setTimeout(function () {
                  return _this2.filesReadyResolve();
                }, 100);
              }).catch(function () {
                return _this2.filesReadyReject();
              });
            } else {
              // этого блока в исходниках не было
              this.refreshDOM();
              this.filesReadyResolve();
            }
          } else {
            this.refreshDOM();
            this.filesReadyResolve();
          }
        }
      }, {
        key: "createImageListItem",
        value: function createImageListItem(fileInfo, index) {
          var _this = this;

          var _this8 = this;

          var image = this.ce('img', {
            alt: fileInfo.originalName || fileInfo.name,
            style: 'width:'.concat(this.component.imageSize, 'px')
          });

          if (this.loadingImages[index]) {
            this.loadingImages[index].then(function (url) {
              image.src = url;
            });
          }

          return this.ce('div', {}, this.ce('span', {}, [image, !this.disabled ? this.ce('i', {
            class: this.iconClass('remove'),
            onClick: function onClick(event) {
              _this8.splice(index);

              _this8.refreshDOM();

              _this.setVisibility(_this.dataValue);

              event.preventDefault();
            }
          }) : null]));
        }
      }, {
        key: "setVisibility",
        value: function setVisibility(filesArray) {
          if (!Array.isArray(filesArray) || !(0, _lodash.isBoolean)(this.component.multiple) || !this.hiddenFileInputElement || this.component.multiple) {
            return;
          }

          this.hiddenFileInputElement.style.display = !filesArray.length ? 'block' : 'none';
        }
      }, {
        key: "createFileLink",
        value: function createFileLink(file) {
          var fileName = this.fileNameWithoutExt(file);

          if (this.options.uploadOnly) {
            return fileName;
          }

          var path = file.url,
              pathPrefix = path.startsWith('/') ? '' : '/',
              url = path.startsWith('http') ? path : "".concat(baseUrl).concat(pathPrefix).concat(path);
          return this.ce('a', {
            href: url,
            target: '_blank'
          }, fileName);
        }
      }, {
        key: "fileExt",
        value: function fileExt(file) {
          var fileName = file.originalName || file.name,
              parts = fileName.split('.');
          return parts.length > 1 ? '.'.concat(parts.pop()) : '';
        }
      }, {
        key: "fileNameWithoutExt",
        value: function fileNameWithoutExt(file) {
          var ext = this.fileExt(file);
          return (file.originalName || file.name).replace(ext, '');
        }
      }, {
        key: "getFile",
        value: function getFile(fileInfo, url) {
          var options = {
            method: 'GET',
            mode: 'cors',
            headers: {
              Accept: '*/*'
            },
            credentials: 'include',
            responseType: 'blob'
          };
          fetch(url, options).then(function (res) {
            return res.blob();
          }).then(function (file) {
            if (file) {
              (0, _jsFileDownload.default)(file, fileInfo.originalName, fileInfo.type);
            }
          });
        }
      }, {
        key: "triggerFileChange",
        value: function triggerFileChange() {
          this.triggerChange({
            modified: true
          });
        }
      }, {
        key: "upload",
        value: function upload(files) {
          _get(_getPrototypeOf(_class.prototype), "upload", this).call(this, baseUrl, files);
        }
      }]);

      return _class;
    }((0, _WithLogic2.default)((0, _WithFileUtils.WithFileUtils)(_File.default, setting)))
  );
}